import { useAjax } from '@composables/useAjax'

export const useCsrfToken = () => {
  const { getCsrfToken } = useAjax()

  return {
    getCsrfToken
  }
}
